export class Actions {
  public static GetLtoById = "LtosGetLtoById";
  public static GetLtoBySlug = "LtosGetLtoBySlug";
  public static GetLtoPrimaryLocationBySlug = "LtosGetLtoPrimaryLocationBySlug";
  public static GetLtoTermsById = "LtosGetLtoTermsById";
  public static GetEnquiryById = "EnquiryGetById";
  public static ClearCurrentEnquiry = "EnquiryClear";
  public static GetEnquiryPayments = "EnquiryGetPayments";
  public static GetEnquiryItinerary = "EnquiryGetItinerary";
  public static RequestEnquiryCancellation = "EnquiryRequestCancellation";
  public static GetAllRegions = "DestinationsGetAllRegions";
  public static GetRegionBySlug = "DestinationsGetRegionBySlug";
  public static GetCountryBySlug = "DestinationsGetCountryBySlug";
  public static GetDestinationBySlug = "DestinationsGetDestinationBySlug";
  public static GetExcursionsByLtoIdAndCountryId = "DestinationsGetExcursionsByLtoIdAndCountryId";
  public static GetLtosByLocationSlug = "DestinationsGetLtosByLocationSlug";
  public static GetCountriesByRegionSlug = "DestinationsGetCountriesByRegionSlug";
  public static GetDestinationsByCountrySlug = "DestinationsGetDestinationsByCountrySlug";
  public static GetAllCountries = "DestinationsGetAllCountries";
  public static GetAllCardTypes = "GetAllCardTypes";
  public static GetExcursionsByLtoId = "DestinationsGetExcursionsByLtoId";
  public static GetSampleItineraryBySlug = "ItinerariesGetSampleItineraryBySlug";
  public static ChangeCurrency = "ChangeSiteCurrency";
  public static LoadAllCurrencies = "SiteLoadAllCurrencies";
  public static GetEnquiriesForCustomer = "CustomerEnquiries";
  public static MarkItineraryViewed = "CustomerMarkItineraryViewed";
  public static GetImageByFileName = "GetImageByFileName";
  public static AddNewTravelerDetails = "AddNewTravelerDetails";
  public static UpdateTravelerDetails = "UpdateTravelerDetails";
  public static AddNewLeadTravelerDetails = "AddNewLeadTravelerDetails";
  public static UpdateLeadTravelerDetails = "UpdateLeadTravelerDetails";
  public static DeleteTravelerDetails = "DeleteTravelerDetails";
  public static CreateReview = "CreateReview";
  public static GetLtoReviews = "GetLtoReviews";

  public static GetContentPage = "GetContentPage";
  public static GetContentSingle = "GetContentSingle";

  public static GetInspirationThemes = "GetInspirationThemes";
  public static GetContentTheme = "GetContentTheme";

  public static ClearCurrentItinerary = "EnquiryItineraryClearCurrent";
  public static GetCurrenciesForQuote = "GetCurrenciesForQuote";

  public static GetEnquiryThemes = "GetEnquiryThemes";
  public static GetEnquiryTheme = "GetEnquiryTheme";

  public static GetAllAgeRanges = "GetAllAgeRanges";

  public static GetFeaturedLocations = "GetFeaturedLocations";

  public static GetTeamProfiles = "GetTeamProfiles";

  public static GetSettings = "GetSettings";
}
